import { MenuOutlined } from '@ant-design/icons';
import { TopMenuIconButton } from '@framework/ui/components/button/TopMenuIconButton.tsx';
import { Dropdown } from '@framework/ui/components/dropdown/Dropdown.tsx';
import { MobileMenuLabel } from '@framework/ui/components/menu/MobileMenuLabel.tsx';
import { useHistory } from '@framework/ui/core/router/TypedRoute.tsx';
import { type ItemType } from 'antd/es/menu/interface';
import { type default as React, useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { type RoutePath } from '../RoutePaths.ts';
import { createMobileSubMenuItems } from './createMobileSubMenuItems.tsx';
import { MenuItemsType } from './MainMenu.tsx';
import { useMainMenuItem } from './useMainMenuItem.tsx';

export interface MobileFullMenuProps {
  extra?: React.ReactNode;
}
/**
 * Pulsante Dropdown  mostrato in modalità Mobile
 * per il menu principale e per il logout dell'utente lato compilazione
 */
export function MobileFullMenu(props: MobileFullMenuProps) {
  const history = useHistory();
  const { t } = useTranslation();
  const theme = useTheme();
  const [menuVisible, setMenuVisible] = useState(false);

  // Definisci la funzione onClick
  const handleMenuClick = useCallback(
    (to: RoutePath) => {
      history.push(to);
    },
    [history],
  );

  const mainMenuItemsBase = useMainMenuItem();

  const menu = useMemo(() => {
    const menuItems = mainMenuItemsBase.map(item => {
      if (item.type === MenuItemsType.PARENT) {
        return {
          key: item.menuKey,
          label: <MobileMenuLabel>{item.children}</MobileMenuLabel>,
          title: item.title,
          children: createMobileSubMenuItems(item.subMenu, handleMenuClick),
        } as ItemType;
      }

      return {
        key: item.menuKey,
        label: <MobileMenuLabel>{item.children}</MobileMenuLabel>,
        title: item.title,
        onClick: () => {
          handleMenuClick(item.to!);
        },
      } as ItemType;
    });
    return { items: menuItems };
  }, [handleMenuClick, mainMenuItemsBase]);

  return (
    <Dropdown
      autoFocus
      placement="bottomRight"
      menu={menu}
      trigger={['click']}
      arrow
      onOpenChange={open => {
        setMenuVisible(open);
      }}
    >
      <TopMenuIconButton
        theme={theme.darkFrontofficeHeaderFlag ? 'negative' : 'positive'}
        aria-expanded={menuVisible}
        aria-haspopup
        aria-label={t('menu.principal-menu', 'Menu Principale')}
        size="large"
        icon={<MenuOutlined aria-hidden="true" />}
      />
    </Dropdown>
  );
}
